import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { addMessage, AddMessageApiParameter } from "@insite/client-framework/Services/MessageService";
import loadMessages from "@insite/client-framework/Store/Data/Messages/Handlers/LoadMessages";
import { MessageModel, CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cart: CartModel;
        message: string;
        onError?: (error: string) => void;
    } & HasOnSuccess,
    AddMessageApiParameter,
    MessageModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        customerOrderId: props.parameter.cart.id,
        message: props.parameter.message,
        toUserProfileName: props.parameter.cart.initiatedByUserName,
        subject: "Sent message",
        process: "OrderApproval",
    };
};

export const SendDataToApi: HandlerType = async props => {
    const result = await addMessage(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const DispatchLoadMessages: HandlerType = props => {
    props.dispatch(
        loadMessages({
            customerOrderId: props.parameter.cart.id,
            process: "OrderApproval",
            expand: "changes",
        }),
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, DispatchLoadMessages, ExecuteOnSuccessCallback];

const sendMessage = createHandlerChainRunner(chain, "SendMessage");
export default sendMessage;
